import axios from '@/axiosInterceptor';

const state = () => ({
  factorList: [],
  latestFactor: [],
});

// getters
const getters = {};

// actions

const actions = {
  async getFactorsDataBySearch({ commit }, search) {
    const params = {
      page: 1,
      per_page: 3,
      'q[s]': 'name asc',
      'q[is_active_true]': 1,
      'q[name_cont]': search,
    };
    try {
      let res = await axios.get(process.env.API_IDENTITY + '/api/v1/factors', {
        params,
      });
      commit('setFactorData', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async assignFactor(
    { commit, rootState },
    { paymentBody, onboardingPacketId }
  ) {
    try {
      let onboardingPacketBody = {
        onboarding_packet: {
          ...paymentBody,
        },
      };
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          onboardingPacketId,
        onboardingPacketBody
      );
      commit('payments/resetEdit', state, { root: true });
      commit(
        'carriers/setCarrierData',
        { ...rootState.carriers.carrierData, ...res.data },
        { root: true }
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  //eslint-disable-next-line
  async createFactor({ commit }, body) {
    try {
      let res = await axios.post(process.env.API_IDENTITY + '/api/v1/factors', {
        factor: body,
      });
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestFactor({ commit }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/factors/receiver_factors'
      );
      if ([200, 201].includes(res.status)) {
        commit('setLatestFactor', res.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setFactorData(state, el) {
    state.factorList = el;
  },
  setLatestFactor(state, el) {
    state.latestFactor = el;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
